import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
// import GD from '../../RestAPI/getData';
import cjquery from 'jquery';
import './Cfavideodisplay.css';
import GMATSubscriptionCheck from '../../RestAPI/GMATSubscription';
import PartnerGMATSubscriptionCheck from '../../RestAPI/PartnerSubscription/GMATSubscription';
import language from '../../../assets/languages/language';
import ModalComponent from '../../Common/Modal';
import { Tooltip } from 'reactstrap';
import AlertMessage from '../../config/alertMessage';
// import { getDeviceDetails } from "../../common/deviceDetails";
import { getIpAddress } from '../../../common/getIpAddress';
import AppRoutes from '../../config/AppRoutes';
import { showFailure } from '../../../common/toast';
import VideoValidateReportIcons from '../../Common/VideoValidateReportIcons';
/* eslint-disable*/
class GMATvideodisplay extends Component {
  constructor(props) {
    window.scrollTo(0, 0);
    super(props);
    var messageTitle_cfa = `<i class="icon-info icons font-2xl d-block "></i>`;
    this.state = {
      alert_status: false,
      successAlert: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class',
      MessageTitle: messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_gmat,
      token: '',
      idname: '',
      ValidToken: false,
      all_questions: '',
      chapters: [],
      all_questions_state: [],
      video_display: '',
      video_display_qq: '',
      url_id: '',
      currentUrl: '',
      reportLoading: false,
      free: '',
      video_title: '',
      video_display_no: '',
      allChapters: [],
      Chapter_Title: '',
      chapterName: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      notesCSS: 'fa fa-book mark-action-btn',
      questionsCSS: 'fa fa-question-circle-o mark-action-btn',
      showFreePremium: this.props.params.showFreePremium === '0' ? true : false,
      currentReading: this.props.params.id,
      comment_update_id: '',
      currentChapterNo: '',
      currentReadingNo: '',
      currentReadingTitle: '',
      subscriptionstatus: '',
      selectedmenu: 'gmat',
      subscription_details_for_isActive: '',
      pdfData: [],
      pdf_file: '',
      type: this.props.params.type === '0' ? 'intro' : 'notintro',
      userType: '',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      saveVideo_text: `${language.LC().SAVE_VIDEO}`,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  _goToPreviousReading() {
    // console.log("this.state.chaptersthis.state.chapters",this.state.chapters[this.state.currentUrl-1].free);
    // const result = getDeviceDetails();
    if (this.state.currentUrl === 0) {
      return;
    }
    this.context.router.push({
      pathname: AppRoutes.GMAT_VIDEO_DISPLAY.replace(':id', this.props.params.id)
        .replace(':showFreePremium', this.props.params.showFreePremium)
        .replace(':type', this.props.params.type)
        .replace(':chapter_id', this.props.params.chapter_id)
        .replace(':index', this.state.currentUrl + 1),

      // `/cfavideodisplay/${this.props.params.id}/${
      //   this.props.params.showFreePremium
      // }/${this.props.params.type}/${this.props.params.chapter_id}/${this.state
      //   .currentUrl + 1}`,
    });
    this.setState({
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveVideo_text: `${language.LC().SAVE_VIDEO}`,
    });
    if (this.state.chapters[this.state.currentUrl - 1].free === 1) {
      // console.log("_goToPreviousReading");

      // if (this.state.currentUrl || this.state.currentUrl) {
      this.setState({ currentUrl: this.state.currentUrl - 1 }, () => {
        this.setState({
          video_display: this.state.chapters[this.state.currentUrl].url_id,
        });
        this.setState({
          video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,
        });
        this.setState({
          video_title: this.state.chapters[this.state.currentUrl].title,
        });
        this.setState({
          currentReading: this.state.chapters[this.state.currentUrl].id,
        });
        this.setState({
          currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,
        });
        this.setState({
          currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,
        });
        this.setState({
          currentReadingTitle: this.state.chapters[this.state.currentUrl].title,
        });
        this.setState({
          pdf_file: this.state.chapters[this.state.currentUrl].pdf_file,
        });
      });
      this.trackUserWatchedVideo(
        this.state.chapters[this.state.currentUrl].id,
        this.state.currentUrl,
      );
    } else {
      const data = { token: this.state.token, idname: this.state.idname };
      FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });

            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              resp_exam => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = PartnerGMATSubscriptionCheck.checkGMATVideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );
                  if (isInArray_var) {
                    this.setState({ currentUrl: this.state.currentUrl - 1 }, () => {
                      this.setState({
                        free: this.state.chapters[this.state.currentUrl].free,
                      });
                      this.setState({
                        video_display: this.state.chapters[this.state.currentUrl].url_id,
                      });
                      this.setState({
                        video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,
                      });
                      this.setState({
                        video_title: this.state.chapters[this.state.currentUrl].title,
                      });
                      this.setState({
                        currentReading: this.state.chapters[this.state.currentUrl].id,
                      });
                      this.setState({
                        currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,
                      });
                      this.setState({
                        currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,
                      });
                      this.setState({
                        currentReadingTitle: this.state.chapters[this.state.currentUrl].title,
                      });
                      this.setState({
                        pdf_file: this.state.chapters[this.state.currentUrl].pdf_file,
                      });
                    });
                    this.trackUserWatchedVideo(
                      this.state.chapters[this.state.currentUrl].id,
                      this.state.currentUrl,
                    );
                    return;
                  } else {
                    // console.log('ELSE WORKING')
                    return this.toggleAlert();
                  }
                } else {
                  // console.log('fail');
                }
              },
            );
          }
        } else {
          if (
            resp.profileInfo.exam_selected === '' &&
            resp.profileInfo.cfaUnlimitedPackage == '' &&
            resp.profileInfo.cfaUnlimitedActiveExam == ''
          ) {
            // console.log("_goToPreviousReading-tooogle");
            return this.toggleAlert();
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });

            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              resp_exam => {
                // console.log(resp_exam);
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = GMATSubscriptionCheck.checkGMATVideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );
                  // console.log(isInArray_var);
                  if (isInArray_var) {
                    // console.log('IF WORKING')
                    // console.log("_goToPreviousReading Premium");
                    this.setState({ currentUrl: this.state.currentUrl - 1 }, () => {
                      this.setState({
                        free: this.state.chapters[this.state.currentUrl].free,
                      });
                      this.setState({
                        video_display: this.state.chapters[this.state.currentUrl].url_id,
                      });
                      this.setState({
                        video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,
                      });
                      this.setState({
                        video_title: this.state.chapters[this.state.currentUrl].title,
                      });
                      this.setState({
                        currentReading: this.state.chapters[this.state.currentUrl].id,
                      });
                      this.setState({
                        currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,
                      });
                      this.setState({
                        currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,
                      });
                      this.setState({
                        currentReadingTitle: this.state.chapters[this.state.currentUrl].title,
                      });
                      this.setState({
                        pdf_file: this.state.chapters[this.state.currentUrl].pdf_file,
                      });
                    });
                    this.trackUserWatchedVideo(
                      this.state.chapters[this.state.currentUrl].id,
                      this.state.currentUrl,
                    );
                    return;
                  } else {
                    // console.log('ELSE WORKING')
                    return this.toggleAlert();
                  }
                } else {
                  // console.log('fail');
                }
              },
            );
          }
        }
      });
    }
  }

  _goToNextReading() {
    // console.log('currentUrl', this.state.currentUrl);
    this.setState({
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveVideo_text: `${language.LC().SAVE_VIDEO}`,
    });
    this.context.router.push({
      pathname: AppRoutes.GMAT_VIDEO_DISPLAY.replace(':id', this.props.params.id)
        .replace(':showFreePremium', this.props.params.showFreePremium)
        .replace(':type', this.props.params.type)
        .replace(':chapter_id', this.props.params.chapter_id)
        .replace(':index', this.state.currentUrl + 1),

      // `/cfavideodisplay/${this.props.params.id}/${
      //   this.props.params.showFreePremium
      // }/${this.props.params.type}/${this.props.params.chapter_id}/${this.state
      //   .currentUrl + 1}`,
    });
    if (this.state.chapters[this.state.currentUrl + 1].free === 1) {
      // console.log("_goToNextReading if");

      this.setState({ currentUrl: this.state.currentUrl + 1 }, () => {
        this.setState({
          video_display: this.state.chapters[this.state.currentUrl].url_id,
        });
        this.setState({
          video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,
        });
        this.setState({
          video_title: this.state.chapters[this.state.currentUrl].title,
        });
        this.setState({
          currentReadingTitle: this.state.chapters[this.state.currentUrl].title,
        });
        this.setState({
          currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,
        });
        this.setState({
          currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,
        });
        this.setState({
          currentReading: this.state.chapters[this.state.currentUrl].id,
        });
        this.setState({
          pdf_file: this.state.chapters[this.state.currentUrl].pdf_file,
        });
      });
      this.trackUserWatchedVideo(
        this.state.chapters[this.state.currentUrl].id,
        this.state.currentUrl,
      );
      return;
    }
    if (this.state.currentUrl === this.state.chapters.length - 1) {
      //  console.log("if");

      // console.log('this.state.currentUrl === (this.state.chapters.length - 1)');
      return;
    } else {
      const data = { token: this.state.token, idname: this.state.idname };
      FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async resp_exam => {
                // console.log(resp_exam);
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = await PartnerGMATSubscriptionCheck.checkGMATVideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );
                  if (isInArray_var) {
                    this.setState({ currentUrl: this.state.currentUrl + 1 }, () => {
                      this.setState({
                        video_display: this.state.chapters[this.state.currentUrl].url_id,
                      });
                      this.setState({
                        video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,
                      });
                      this.setState({
                        video_title: this.state.chapters[this.state.currentUrl].title,
                      });
                      this.setState({
                        currentReading: this.state.chapters[this.state.currentUrl].id,
                      });
                      this.setState({
                        currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,
                      });
                      this.setState({
                        currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,
                      });
                      this.setState({
                        currentReadingTitle: this.state.chapters[this.state.currentUrl].title,
                      });
                      this.setState({
                        pdf_file: this.state.chapters[this.state.currentUrl].pdf_file,
                      });
                    });
                    this.trackUserWatchedVideo(
                      this.state.chapters[this.state.currentUrl].id,
                      this.state.currentUrl,
                    );
                    return;
                  } else {
                    return this.toggleAlert();
                  }
                } else {
                  console.log('fail');
                }
              },
            );
          }
        } else {
          if (
            resp.profileInfo.exam_selected === '' &&
            resp.profileInfo.cfaUnlimitedPackage == '' &&
            resp.profileInfo.cfaUnlimitedActiveExam == ''
          ) {
            // console.log("working");
            // console.log("_goToNextReading toggleAlert");

            return this.toggleAlert();
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              resp_exam => {
                // console.log(resp_exam);
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = GMATSubscriptionCheck.checkGMATVideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );
                  if (isInArray_var) {
                    // console.log("_goToNextReading Premium");

                    // console.log('IF WORKING')
                    this.setState({ currentUrl: this.state.currentUrl + 1 }, () => {
                      this.setState({
                        video_display: this.state.chapters[this.state.currentUrl].url_id,
                      });
                      this.setState({
                        video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,
                      });
                      this.setState({
                        video_title: this.state.chapters[this.state.currentUrl].title,
                      });
                      this.setState({
                        currentReading: this.state.chapters[this.state.currentUrl].id,
                      });
                      this.setState({
                        currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,
                      });
                      this.setState({
                        currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,
                      });
                      this.setState({
                        currentReadingTitle: this.state.chapters[this.state.currentUrl].title,
                      });
                      this.setState({
                        pdf_file: this.state.chapters[this.state.currentUrl].pdf_file,
                      });
                    });
                    this.trackUserWatchedVideo(
                      this.state.chapters[this.state.currentUrl].id,
                      this.state.currentUrl,
                    );

                    return;
                  } else {
                    // console.log('ELSE WORKING')
                    return this.toggleAlert();
                  }
                } else {
                  console.log('fail');
                }
              },
            );
          }
        }
      });
    }
  }

  // function to track user watched video
  trackUserWatchedVideo = (id, index) => {
    // const result = getDeviceDetails();
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      id: id,
      videoIndex: index,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/trackUserVideowatch', data).then(
      async resp => {},
    );
  };

  pdfOpen = (pdfdata, e, index = 0) => {
    const { chapters, currentUrl } = this.state;
    if (this.state.userType === 'paid') {
      // const result = getDeviceDetails();
      const data = {
        token: this.state.token,
        idname: this.state.idname,
        id: chapters[currentUrl].id,
        videoIndex: currentUrl,
        city: this.state.user_city,
        country: this.state.user_country,
        state: this.state.user_state,
        continent: this.state.user_continent,
        ip: this.state.user_ip,
      };
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/trackUserVideoPPTDownload', data).then(
        resp => {
          if (resp.success) {
            var myWindow = window.open(this.state.pdf_file);
            myWindow.focus();
          }
          return resp;
        },
      );
    } else {
      this.toggleAlert();
    }
  };

  //Function to show Report box
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  _downloadPDF = () => {
    // console.log('Download PDF')
  };

  //Function to hide Report box
  _hideReportForm = (item, e) => {
    document.getElementById('comment').value = '';
    this.setState({ report_block: 'card hide_block' });
  };

  //Function to save new report question
  _reportQuestion = id => {
    var comment = document.getElementById('comment').value;
    // console.log('function calling...', comment.length);

    if (comment.length < 2) {
      return;
    }
    // const result = getDeviceDetails();
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      video_id: id,
      comment: comment,
      videoIndex: this.state.currentUrl,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };

    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoReportQuestion', data).then(
      resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            successAlert: true,
            reportLoading: false,
          });
          document.getElementById('comment').value = '';
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  //Function to toggle Comment box
  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  //Function to toggle Flash box
  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  //Function to save comment And display new comment
  _saveComment = id => {
    // console.log('_saveComment');
    if (document.getElementById('ques_comment').value === '') {
      return;
    }
    var comment = document.getElementById('ques_comment').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      video_id: id,
      comment: comment,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoSaveComment', data).then(resp => {
      // console.log(resp);

      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('ques_comment').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          video_id: id,
        };
        // console.log(params);

        FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoGetComments', params).then(
          response => {
            // console.log(response);
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.comments.length > 0) {
                var comments = response.comments.map(items => (
                  <li key={items.id}>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      {language.LC().BY} {items.username} {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                var comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              var comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  //Function to Edit particular comment
  _editComment = (item, e) => {
    document.getElementById('ques_comment').value = item.comment;
    this.setState({ comment_update: 'btn btn-primary active pointer_class' });
    this.setState({ comment_save: 'hide_block' });
    this.setState({ comment_update_id: item.id });
  };

  //Function to Update Comment
  _updateComment = async id => {
    // console.log(id);

    if (document.getElementById('ques_comment').value == '') {
      return;
    }
    var comment = document.getElementById('ques_comment').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      comment_id: this.state.comment_update_id,
      comment: comment,
    };
    await FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoUpdateComment', data).then(
      async resp => {
        // console.log(resp);
        if (resp.success) {
          // console.log('if working');
          this.setState({ ValidToken: true });
          document.getElementById('ques_comment').value = '';
          this.setState({ comment_update: 'hide_block' });
          this.setState({ comment_save: 'btn btn-primary active pointer_class' });
          this.setState({ comment_update_id: '' });
          document.getElementById('ques_comment').value = '';
          var params = {
            token: this.state.token,
            idname: this.state.idname,
            video_id: id,
          };
          // console.log(params);

          await FD.callAPI(
            App_data.backend_api + '/gmat_question_bank/videoGetComments',
            params,
          ).then(async response => {
            // console.log('getComments');
            // console.log(response);
            if (response.success) {
              this.setState({ ValidToken: true });

              if (response.comments.length > 0) {
                // console.log('IF working');
                var comments = response.comments.map((items, index) => (
                  <li key={index}>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      By {items.username} {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                // console.log('ELSE working');
                var comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              var comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          });
        } else {
          this.setState({ ValidToken: false });
        }
        /// return resp;
      },
    );
  };

  //Function to delete particular comment
  _deleteComment = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      comment: item,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoDeleteComment', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('ques_comment').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          video_id: item.video_id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoGetComments', params).then(
          response => {
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.comments.length > 0) {
                var comments = response.comments.map(items => (
                  <li>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      By {items.username} {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                var comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              var comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  //Function to Save flash Card And display new stored flash card
  _saveFlashCard = (id, e) => {
    if (document.getElementById('flash_card').value === '') {
      return;
    }
    var flash_card = document.getElementById('flash_card').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      video_id: id,
      flash_card: flash_card,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoSaveFlashCards', data).then(
      resp => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          document.getElementById('flash_card').value = '';
          var params = {
            token: this.state.token,
            idname: this.state.idname,
            video_id: id,
          };
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoGetFlashCards', params).then(
            response => {
              if (response.success) {
                this.setState({ ValidToken: true });
                if (response.flash_cards.length > 0) {
                  this.setState({
                    flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                  });
                  var flash_cards = response.flash_cards.map(items => (
                    <li key={items.id}>
                      <div className=''>
                        <ul className='icon_list'>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._editFlash.bind(this, items)}
                            >
                              <i className='fa fa-pencil' />
                            </a>
                          </li>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._deleteFlash.bind(this, items)}
                            >
                              <i className='fa fa-close' />
                            </a>
                          </li>
                        </ul>
                        <div className={this.state.flash_class}>
                          <h4 />
                          <p>{items.flash_card}</p>
                        </div>
                      </div>
                    </li>
                  ));
                } else {
                  this.setState({
                    flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                  });
                  var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                }
                this.setState({ flash_data: flash_cards });
              } else {
                var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                this.setState({ ValidToken: false });
                this.setState({ flash_data: flash_cards });
                this.setState({
                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                });
              }
              return response;
            },
          );
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
  };

  //Function to Edit Flash card
  _editFlash = (item, e) => {
    this.setState({
      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
    });
    document.getElementById('flash_card').value = item.flash_card;
  };

  //Function to delete flash card
  _deleteFlash = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoDeleteFlashCards', data).then(
      resp => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({
            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
          });
          document.getElementById('flash_card').value = '';
          var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          this.setState({ flash_data: flash_cards });
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
  };

  _getChapters = e => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_VIDEO_LESSONS,
    });
  };

  // Function to redirect page to viewquestions page
  moveToPracticeQuestions = () => {
    var final_exam = [];
    var user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await PartnerGMATSubscriptionCheck.checkGMATVideosSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );

                if (isInArray_var) {
                  this._runCode('paid');
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this._runCode('free');
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage == '' &&
          resp.profileInfo.cfaUnlimitedActiveExam == ''
        ) {
          return this.toggleAlert();
        } else {
          // console.log(resp, 'sssssssssssssssssssssssss');
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              // console.log(resp_exam);
              if (resp_exam.success) {
                // console.log('If working');
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = GMATSubscriptionCheck.checkGMATVideosSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                // console.log('selectedmen--------------------', selectedmen);
                // console.log('isInArray_var--------------------', isInArray_var);

                if (isInArray_var) {
                  this._runCode('paid');
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this._runCode('free');
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  _runCode(subscriptionstatus) {
    // console.log('hiyuuuuuuuuu', subscriptionstatus);
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: this.state.currentReadingNo,
      chapter_id: this.state.currentChapterNo,
      offset: 0,
      limit: 1,
      subscriptionstatus: subscriptionstatus,
    };
    // console.log(data);
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getQuestions', data).then(resp => {
      // console.log('resp');
      if (resp && resp.success) {
        if (resp.questions.length) {
          this.context.router.push({
            pathname: AppRoutes.GMAT_QUESTION_BANK_LIST_QUE.replace(
              ':chapter_no',
              this.state.currentChapterNo,
            )
              .replace(':id', this.state.currentReadingNo)
              .replace(':subscriptionstatus', this.state.subscriptionstatus)
              .replace(':reading', this.state.currentReadingTitle),
          });
        } else {
          showFailure('No questions found');
        }
      } else {
        this.toggleAlert();
      }
    });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.currentReading !== this.state.currentReading) {
      var params = {
        token: this.state.token,
        idname: this.state.idname,
        video_id: this.state.currentReading,
      };
      await this.getSavedVideo(this.state.currentReading);
      await FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoGetComments', params).then(
        async response => {
          var comments = '';
          if (response.success) {
            this.setState({ ValidToken: true });
            if (response.comments.length > 0) {
              comments = response.comments.map((items, index) => (
                <li key={index}>
                  {response.user_id == items.uid ? (
                    <ul className='icon_list'>
                      <li>
                        <a className='pointer_class' onClick={this._editComment.bind(this, items)}>
                          <i className='fa fa-pencil' />
                        </a>
                      </li>
                      <li>
                        <a
                          className='pointer_class'
                          onClick={this._deleteComment.bind(this, items)}
                        >
                          <i className='fa fa-close' />
                        </a>
                      </li>
                    </ul>
                  ) : (
                    <ul />
                  )}

                  <h4>
                    {language.LC().BY} {items.username} {new Date(items.createdAt).toDateString()}
                  </h4>
                  <p>{items.comment}</p>
                </li>
              ));

              this.setState({ comment_data: comments });
            } else {
              comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
            }
          } else {
            comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
            this.setState({ comment_data: comments });
            this.setState({ ValidToken: false });
          }
          return response;
        },
      );

      var params = {
        token: this.state.token,
        idname: this.state.idname,
        video_id: this.state.currentReading,
      };
      await FD.callAPI(
        App_data.backend_api + '/gmat_question_bank/videoGetFlashCards',
        params,
      ).then(response => {
        var flash_cards = '';
        if (response.success) {
          this.setState({ ValidToken: true });
          if (response.flash_cards.length > 0) {
            this.setState({
              flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
            });
            flash_cards = response.flash_cards.map((items, index) => (
              <li key={index}>
                <div className=''>
                  <ul className='icon_list'>
                    <li>
                      <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                        <i className='fa fa-pencil' />
                      </a>
                    </li>
                    <li>
                      <a className='pointer_class' onClick={this._deleteFlash.bind(this, items)}>
                        <i className='fa fa-close' />
                      </a>
                    </li>
                  </ul>
                  <div className={this.state.flash_class}>
                    <h4 />
                    <p>{items.flash_card}</p>
                  </div>
                </div>
              </li>
            ));
          } else {
            this.setState({
              flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
            });
            flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          }
          this.setState({ flash_data: flash_cards });
        } else {
          flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          this.setState({ ValidToken: false });
          this.setState({ flash_data: flash_cards });
          this.setState({
            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
          });
        }
      });
    }
  }

  async componentDidMount() {
    const { location } = this.props;
    const { chapter_name = '' } = location.query;
    if (chapter_name) {
      this.setState({
        chapterName: chapter_name,
      });
    }
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    if (this.state.showFreePremium) {
      this.setState({ userType: 'free' });
    } else if (!this.state.showFreePremium) {
      this.setState({ userType: 'paid' });
    }
    if (this.props.params.index) {
      // console.log('IF Working');
      this.setState({
        currentUrl: this.props.params.index ? parseInt(this.props.params.index) : 0,
      });
    } else {
      // console.log('Else Working');
      this.setState({ currentUrl: 0 });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      chapter_id:
        this.props.params.chapter_id !== ':chapter_id'
          ? this.props.params.chapter_id
          : this.props.params.id,
    };
    // console.log('this.propsssssssssssssss', this.props);
    await FD.callAPI(
      App_data.backend_api + '/gmat_question_bank/getGMATVideosChapterwise',
      data,
    ).then(async resp => {
      // console.log('resp--------------------------------------------', resp);
      if (resp.success) {
        await this.setState({ ValidToken: true });
        await this.setState({ chapters: resp.cfavchapter });
        if (
          this.state.chapters &&
          this.state.chapters.length &&
          this.state.chapters[this.state.currentUrl]
        ) {
          await this.setState({
            pdf_file:
              this.state.chapters[this.state.currentUrl] &&
              this.state.chapters[this.state.currentUrl].pdf_file
                ? this.state.chapters[this.state.currentUrl].pdf_file
                : null,
          });
          await this.setState({
            currentReading: this.state.chapters[this.state.currentUrl].id,
          });
          await this.setState({
            video_display: this.state.chapters[this.state.currentUrl].url_id,
          });
          await this.setState({
            video_display_qq: this.state.chapters[this.state.currentUrl].url_id_qq,
          });
          await this.setState({
            video_display_previous: this.state.chapters[this.state.currentUrl].url_id,
          });
          await this.setState({
            video_title: this.state.chapters[this.state.currentUrl].title,
          });
          await this.setState({
            video_display_next: this.state.chapters[this.state.currentUrl + 1]
              ? this.state.chapters[this.state.currentUrl + 1].url_id
              : null,
          });
          await this.setState({
            currentChapterNo: this.state.chapters[this.state.currentUrl].chapter_id,
          });
          await this.setState({
            currentReadingNo: this.state.chapters[this.state.currentUrl].reading_no,
          });
          await this.setState({
            currentReadingTitle: this.state.chapters[this.state.currentUrl].title,
          });
        }
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    await FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATVideos', data).then(
      resp => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({ allChapters: resp.cfavideo });
          this.props.params.chapter_id === undefined
            ? null
            : this.setState({
                Chapter_Title:
                  resp.cfavideo &&
                  resp.cfavideo[this.props.params.chapter_id - 1] &&
                  resp.cfavideo[this.props.params.chapter_id - 1].chapter_name
                    ? resp.cfavideo[this.props.params.chapter_id - 1].chapter_name
                    : '',
              });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
    var params = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      video_id: this.state.currentReading,
    };

    await this.getSavedVideo(this.state.currentReading);

    await FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoGetComments', params).then(
      response => {
        var comments = '';
        if (response.success) {
          this.setState({ ValidToken: true });
          if (response.comments.length > 0) {
            comments = response.comments.map((items, index) => (
              <li key={index}>
                {response.user_id == items.uid ? (
                  <ul className='icon_list'>
                    <li>
                      <a className='pointer_class' onClick={this._editComment.bind(this, items)}>
                        <i className='fa fa-pencil' />
                      </a>
                    </li>
                    <li>
                      <a className='pointer_class' onClick={this._deleteComment.bind(this, items)}>
                        <i className='fa fa-close' />
                      </a>
                    </li>
                  </ul>
                ) : (
                  <ul />
                )}

                <h4>
                  {language.LC().BY} {items.username} {new Date(items.createdAt).toDateString()}
                </h4>
                <p>{items.comment}</p>
              </li>
            ));

            this.setState({ comment_data: comments });
          } else {
            comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
            this.setState({ comment_data: comments });
          }
        } else {
          comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
          this.setState({ comment_data: comments });
          this.setState({ ValidToken: false });
        }
        return response;
      },
    );

    var params = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      video_id: this.state.currentReading,
    };
    await FD.callAPI(App_data.backend_api + '/gmat_question_bank/videoGetFlashCards', params).then(
      response => {
        var flash_cards = '';
        if (response.success) {
          this.setState({ ValidToken: true });
          if (response.flash_cards.length > 0) {
            this.setState({
              flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
            });
            flash_cards = response.flash_cards.map((items, index) => (
              <li key={index}>
                <div className=''>
                  <ul className='icon_list'>
                    <li>
                      <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                        <i className='fa fa-pencil' />
                      </a>
                    </li>
                    <li>
                      <a className='pointer_class' onClick={this._deleteFlash.bind(this, items)}>
                        <i className='fa fa-close' />
                      </a>
                    </li>
                  </ul>
                  <div className={this.state.flash_class}>
                    <h4 />
                    <p>{items.flash_card}</p>
                  </div>
                </div>
              </li>
            ));
          } else {
            this.setState({
              flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
            });
            flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          }
          this.setState({ flash_data: flash_cards });
        } else {
          flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          this.setState({ ValidToken: false });
          this.setState({ flash_data: flash_cards });
          this.setState({
            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
          });
        }
      },
    );

    var params = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    await FD.callAPI(App_data.backend_api + '/gmat_question_bank/getgmat_video_pdf', data).then(
      resp => {
        if (resp.success) {
          // console.log(resp);
          this.setState({ pdfData: resp });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  getSavedVideo = async data => {
    var params = {
      token: this.state.token,
      question_id: data,
      idname: this.state.idname,
    };
    await FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavVideo', params).then(
      response => {
        if (response.success) {
          this.setState({
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            saveVideo_text: `${language.LC().Video_Saved}`,
            bookmarkColor: 'rgb(54, 141, 84)',
          });
        }
      },
    );
  };

  toggleAlert = () => {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  };

  goPremium = () => {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  getVideourl = async (index, url_id, title, id, url_id_qq, free, item) => {
    if (free === 1) {
      this.setState(
        {
          video_display: url_id,
          video_display_qq: url_id_qq,
          currentUrl: index,
          video_title: title,
          currentReading: item.id,
          currentChapterNo: item.chapter_id,
          currentReadingNo: item.reading_no,
          currentReadingTitle: item.title,
          pdf_file: item.pdf_file,
        },
        () => {
          this.context.router.push({
            pathname: AppRoutes.GMAT_VIDEO_DISPLAY.replace(':id', this.props.params.id)
              .replace(':showFreePremium', this.props.params.showFreePremium)
              .replace(':type', this.props.params.type)
              .replace(':chapter_id', this.props.params.chapter_id)
              .replace(':index', this.state.currentUrl),

            // `/cfavideodisplay/${this.props.params.id}/${
            //   this.props.params.showFreePremium
            // }/${this.props.params.type}/${this.props.params.chapter_id}/${
            //   this.state.currentUrl
            // }`,
          });
        },
      );

      await this.savelastVideo(id, index);
      await this.trackUserWatchedVideo(id, index);
    } else {
      const data = { token: this.state.token, idname: this.state.idname };
      FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async resp_exam => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = await PartnerGMATSubscriptionCheck.checkGMATVideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );
                  if (isInArray_var) {
                    this.setState(
                      {
                        video_display: url_id,
                        video_display_qq: url_id_qq,
                        currentUrl: index,
                        video_title: title,
                        currentReading: item.id,
                        currentChapterNo: item.chapter_id,
                        currentReadingNo: item.reading_no,
                        currentReadingTitle: item.title,
                        pdf_file: item.pdf_file,
                      },
                      () => {
                        this.context.router.push({
                          pathname: AppRoutes.GMAT_VIDEO_DISPLAY.replace(
                            ':id',
                            this.props.params.id,
                          )
                            .replace(':showFreePremium', this.props.params.showFreePremium)
                            .replace(':type', this.props.params.type)
                            .replace(':chapter_id', this.props.params.chapter_id)
                            .replace(':index', this.state.currentUrl),

                          // `/cfavideodisplay/${this.props.params.id}/${
                          //   this.props.params.showFreePremium
                          // }/${this.props.params.type}/${
                          //   this.props.params.chapter_id
                          // }/${this.state.currentUrl}`,
                        });
                      },
                    );
                    await this.savelastVideo(id, index);
                    await this.trackUserWatchedVideo(id, index);
                    return;
                  } else {
                    return this.toggleAlert();
                  }
                } else {
                  console.log('fail');
                }
              },
            );
          }
        } else {
          if (
            resp.profileInfo.exam_selected === '' &&
            resp.profileInfo.cfaUnlimitedPackage == '' &&
            resp.profileInfo.cfaUnlimitedActiveExam == ''
          ) {
            // console.log("if working");

            return this.toggleAlert();
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });

            // console.log('else working');
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async resp_exam => {
                // console.log(resp_exam);
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = await GMATSubscriptionCheck.checkGMATVideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );
                  // console.log(isInArray_var);
                  if (isInArray_var) {
                    // console.log('IF WORKING')
                    this.setState(
                      {
                        video_display: url_id,
                        video_display_qq: url_id_qq,
                        currentUrl: index,
                        video_title: title,
                        currentReading: item.id,
                        currentChapterNo: item.chapter_id,
                        currentReadingNo: item.reading_no,
                        currentReadingTitle: item.title,
                        pdf_file: item.pdf_file,
                      },
                      () => {
                        this.context.router.push({
                          pathname: AppRoutes.GMAT_VIDEO_DISPLAY.replace(
                            ':id',
                            this.props.params.id,
                          )
                            .replace(':showFreePremium', this.props.params.showFreePremium)
                            .replace(':type', this.props.params.type)
                            .replace(':chapter_id', this.props.params.chapter_id)
                            .replace(':index', this.state.currentUrl),

                          // `/cfavideodisplay/${this.props.params.id}/${
                          //   this.props.params.showFreePremium
                          // }/${this.props.params.type}/${
                          //   this.props.params.chapter_id
                          // }/${this.state.currentUrl}`,
                        });
                      },
                    );
                    await this.savelastVideo(id, index);
                    await this.trackUserWatchedVideo(id, index);
                    return;
                  } else {
                    // console.log('ELSE WORKING')
                    return this.toggleAlert();
                  }
                } else {
                  console.log('fail');
                }
              },
            );
          }
        }
      });
    }
  };

  /*
  saved viewed video
*/

  savelastVideo = async (id, index) => {
    const { token, idname } = this.state;
    var data_data = {
      token: token,
      idname: idname,
      video_id: id,
      videoIndex: index,
    };
    await FD.callAPI(
      App_data.backend_api + '/gmat_question_bank/saveLastViewedVideo',
      data_data,
    ).then(response => {
      if (response.success) {
        this.setState({
          ValidToken: true,
        });
      }
    });
  };

  //Function to Display Saved Question on button and save in database
  _saveFavVideo = (item, e) => {
    // console.log('_saveFavVideo', item);

    var data = {
      token: this.state.token,
      idname: this.state.idname,
      video_id: item,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      // return;

      FD.callAPI(App_data.backend_api + '/gmat_question_bank/unsaveFavVideoByUserID', data).then(
        resp => {
          if (resp.success) {
            this.setState({
              ValidToken: true,
              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
              bookmarkColor: '',
              saveVideo_text: `${language.LC().SAVE_VIDEO}`,
            });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );
    } else {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveFavVideoByUserID', data).then(
        resp => {
          if (resp.success) {
            this.setState({
              ValidToken: true,
              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              bookmarkColor: 'rgb(54, 141, 84)',
              saveVideo_text: `${language.LC().Video_Saved}`,
            });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );
    }
  };

  render() {
    var domainApp = localStorage.getItem('domainApp');
    const { reportLoading, type } = this.state;

    let chapters = this.state.chapters;
    const styles_css = {
      marginBottom: '20px',
    };
    let data = '';
    if (this.state.chapters.length) {
      data = chapters.map((item, index) => (
        <div key={item.id}>
          <div className='full-width' key={item.id}>
            <div className='videotitle' key={item.id} value={item.id}>
              {this.state.showFreePremium ? (
                item.free === 1 || type === 'intro' ? (
                  <div className='video-type-free'>{language.LC().FREE}</div>
                ) : (
                  <div className='video-type-primum'>{language.LC().PREMIUM}</div>
                )
              ) : (
                <div />
              )}
              <button
                type='button'
                name='videourl'
                id={item.id}
                className={item.url_id === this.state.video_display ? 'active' : ''}
                onClick={this.getVideourl.bind(
                  this,
                  index,
                  item.url_id,
                  item.title,
                  item.id,
                  item.url_id_qq,
                  item.free,
                  item,
                )}
                value={item.url}
              >
                <i className='fa fa-play-circle' />
                <div className='text-overflow'>{item.title}</div>
              </button>
            </div>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='col-sm-6 col-md-4'>
          <div className='card card-inverse card-primary'>
            <div className='card-header'>{language.LC().NO_RECORD_FOUND}</div>
            <div className='card-block' />
          </div>
        </div>
      );
    }

    return (
      <div className='coming_soon_wrap'>
        <div className='row'>
          <div className='col-xs-12 col-sm-6 col-md-6'>
            {type === 'intro' ? (
              <h4> Introduction </h4>
            ) : this.state.Chapter_Title ? (
              <h4> {this.state.Chapter_Title}</h4>
            ) : this.state.chapterName ? (
              <h4> {this.state.chapterName}</h4>
            ) : null}
          </div>
          <div className='col-xs-12 col-sm-6 col-md-6 text-right' style={styles_css}>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getChapters}
            >
              {language.LC().BACK_TO_VIDEOS}
            </button>
          </div>
        </div>
        <div>
          {this.state.chapters.length === 0 ? (
            <div className='loader_box'>
              <div className='sk-circle'>
                <div className='sk-circle1 sk-child' />
                <div className='sk-circle2 sk-child' />
                <div className='sk-circle3 sk-child' />
                <div className='sk-circle4 sk-child' />
                <div className='sk-circle5 sk-child' />
                <div className='sk-circle6 sk-child' />
                <div className='sk-circle7 sk-child' />
                <div className='sk-circle8 sk-child' />
                <div className='sk-circle9 sk-child' />
                <div className='sk-circle10 sk-child' />
                <div className='sk-circle11 sk-child' />
                <div className='sk-circle12 sk-child' />
              </div>
            </div>
          ) : (
            <div>
              <div className='video_outer'>
                <div className='row'>
                  <div className='col-xs-12 col-sm-8 col-md-8'>
                    <h5 className='mb-0'>{this.state.video_title}</h5>
                  </div>
                  <div className='col-xs-12 col-sm-4 col-md-4' style={styles_css}>
                    <div className='float-right text-right'>
                      {this.state.currentUrl === 0 ? null : (
                        <i
                          className='fa fa-angle-left ques_arrow pointer_class'
                          onClick={this._goToPreviousReading.bind(this)}
                        />
                      )}

                      {this.state.currentUrl === this.state.chapters.length - 1 ? null : (
                        <i
                          className='fa fa-angle-right ques_arrow pointer_class'
                          onClick={this._goToNextReading.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className='row videos-main-wraper p-0'>
                  {/* <div className="videos-main-block"> */}
                  <div className='col-xs-12 col-sm-9 col-md-9 video-show-section'>
                    <div className='' id='video-height'>
                      {this.state.video_display_qq === '' ? (
                        <div className='embed-responsive embed-responsive-16by9'>
                          <iframe
                            className='embed-responsive-item'
                            width={'100%'}
                            height={'100%'}
                            title={'video'}
                            frameBorder='0'
                            src={`https://www.youtube.com/embed/${
                              this.state.video_display
                            }?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 `}
                            allowFullScreen
                            sandbox='allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'

                            //controls={false}
                            // showinfo={0}
                            // autohide={1}
                          />
                        </div>
                      ) : (
                        <div className='embed-responsive embed-responsive-16by9'>
                          <iframe
                            width='100%'
                            allowFullScreen='1'
                            height='100%'
                            position='absolute'
                            top='10'
                            left='0'
                            src={`//ljsp.lwcdn.com/api/video/embed.jsp?id=${
                              this.state.video_display_qq
                            }&pi=080de783-b4bf-4b42-ac09-e782c8a907ef`}
                            sandbox='allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
                            frameBorder='0'
                            title='0'
                            byline='0'
                            portrait='0'
                            frameborder='10'
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className='col-xs-12 col-sm-3 col-md-3 video-tag-heading'
                    id='video-tag-list'
                  >
                    <div className='link_list_wrap'>{data}</div>
                  </div>
                  {/* </div> */}
                </div>
              </div>
              <div> </div>
              <br /> <br />
              <div className='col-sm-12'>
                <VideoValidateReportIcons
                  moveToNotes={this.moveToNotes}
                  // notesCSS={this.state.notesCSS}
                  moveToPracticeQuestions={this.moveToPracticeQuestions}
                  _saveFavVideo={this._saveFavVideo}
                  _displayReportForm={this._displayReportForm}
                  pdfOpen={this.pdfOpen}
                  noPDFInExam={this.state.pdf_file ? false : true}
                  bookmarkCSS={this.state.bookmarkCSS}
                  bookmarkColor={this.state.bookmarkColor}
                  type={this.state.type}
                  questionsCSS={this.state.questionsCSS}
                  saveVideo_text={this.state.saveVideo_text}
                  currentReading={this.state.currentReading}
                  chapters={this.state.chapters}
                  showFreePremium={this.state.showFreePremium}
                />
                {/* <span>
                  {this.state.type === 'intro' ||
                  (this.state.chapters &&
                    this.state.chapters[0].chapter_id === 11) ? null : (
                    <span
                      className='up tooltip-hover-questions'
                      style={{ padding: '10px' }}
                    >
                      <div className='tootip_box'>
                        {' '}
                        {language.LC().GO_TO_QUESTION_BANK}{' '}
                      </div>
                      <i
                        onClick={this.moveToPracticeQuestions.bind('123')}
                        className={this.state.questionsCSS}
                        style={{ color: '#1d364b' }}
                      >
                        {' '}
                      </i>
                    </span>
                  )}
                  {this.state.type === 'intro' ? null : (
                    <span
                      className='up tooltip-hover-questions'
                      style={{ padding: '10px' }}
                    >
                      <div className='tootip_box'>
                        {' '}
                        {this.state.saveVideo_text}{' '}
                      </div>
                      <i
                        onClick={this._saveFavVideo.bind(
                          this,
                          this.state.currentReading
                        )}
                        className={this.state.bookmarkCSS}
                        style={{ color: this.state.bookmarkColor }}
                      >
                        {' '}
                      </i>
                    </span>
                  )}
                </span> */}
                {/* <span
                  className='up tooltip-hover-questions'
                  style={{ padding: '10px' }}
                >
                  <div className='tootip_box'>
                    {' '}
                    {language.LC().REPORT_THIS_QUESTION}{' '}
                  </div>
                  <i
                    onClick={this._displayReportForm.bind()}
                    className={this.state.flagCSS}
                  >
                    {' '}
                  </i>
                </span> */}
                {/* <span
                  className='up tooltip-hover-questions vertical-align-middle'
                  style={{ padding: '10px' }}
                >
                  <div className='tootip_box'>
                    {' '}
                    {language.LC().REPORT_THIS_QUESTION}{' '}
                  </div>
                  <div
                    className='report-icon-wrapper'
                    onClick={this._displayReportForm.bind()}
                  >
                    <img
                      src={App_data.frontend_url + '/img/report4.png'}
                      alt='report'
                    />
                  </div>
                </span> */}
                {/* {console.log('I am here -----> ', this.state.pdf_file)}
                {this.state.pdf_file ? (
                  <div
                    onClick={this.pdfOpen.bind()}
                    className='status-download-btn'
                  >
                    <a className='btn btn-primary  pointer_class pull-right'>
                      <i className='fa fa-download  ' aria-hidden='true' />
                      {this.state.showFreePremium ? (
                        <div className='premium-download'>
                          {language.LC().PREMIUM}
                        </div>
                      ) : null}
                      {language.LC().Download_PDF}
                    </a>
                  </div>
                ) : (
                  ''
                )} */}
              </div>
              <br /> <br />
              <div className='row'>
                <div className='col-md-12'>
                  <div className={this.state.report_block}>
                    <div className='card-header'>
                      {language.LC().REPORT}
                      {/* <TooltipItem
                      key="1"
                      id="1"
                      content={this.state.tooltips[1].placement}
                      place_tip={this.state.tooltips[1].text_align}
                    /> */}
                    </div>
                    {!this.state.successAlert ? (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong>{language.LC().COMMENT}</strong>
                            </label>
                          </div>
                          <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10'>
                            <textarea
                              id='comment'
                              name='comment'
                              rows='6'
                              className='form-control'
                              placeholder='Content..'
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class report-btn'
                              disabled={reportLoading}
                              onClick={this._reportQuestion.bind(this, this.state.currentReading)}
                            >
                              {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                            </button>
                            <button
                              type='button'
                              className='btn btn-danger active pointer_class margin_left_10'
                              onClick={this._hideReportForm.bind(this)}
                            >
                              {language.LC().CANCEL}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 report-Success-card'>
                            <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                            </label>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class  min-vw-120'
                              onClick={this.onClose}
                            >
                              {' '}
                              {language.LC().CLOSE}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='row'>
                {/* <div className='col-md-6'>
                  <div className='card'>
                    <div
                      className='card-header pointer_class'
                      onClick={this._getToggleComment.bind()}
                    >
                      {language.LC().COMMENT}
                      <TooltipItem
                        key='0'
                        id='0'
                        content={this.state.tooltips[0].placement}
                        place_tip={this.state.tooltips[0].text_align}
                      />
                      <div className='float-right text-right'>
                        <img
                          src={
                            App_data.frontend_url + '/img/arrow_down_ico.png'
                          }
                          alt=''
                        />
                      </div>
                    </div>

                    <div style={{ display: 'none' }} ref='comment_toggle_div'>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <ul className='comment_list_wrapper'>
                              {this.state.comment_data}
                            </ul>
                          </div>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <form>
                              <textarea
                                id='ques_comment'
                                name='ques_comment'
                                rows='6'
                                className='form-control margin_bottom_10'
                                placeholder='Comment'
                              />
                              <button
                                type='button'
                                className={this.state.comment_save}
                                onClick={this._saveComment.bind(
                                  this,
                                  this.state.currentReading
                                )}
                              >
                                {language.LC().COMMENT}
                              </button>
                              <button
                                type='button'
                                className={this.state.comment_update}
                                onClick={this._updateComment.bind(
                                  this,
                                  this.state.currentReading
                                )}
                              >
                                {language.LC().UPDATE_COMMENT}
                              </button>
                              <p>
                                *
                                {
                                  language.LC()
                                    .YOU_CAN_USE_THE_COMMENT_SECTION_TO_ASK_A_QUESTION_OR_TO_SHOW_HOW_YOU_SOLVED_THE_PROBLEM_Dont_hesitate_to_share_your_thoughts_it_could_help_other_candidates
                                }{' '}
                              </p>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className='col-md-6 d-none'>
                  <div className='card'>
                    <div
                      className='card-header pointer_class'
                      onClick={this._getToggleFlash.bind()}
                    >
                      {language.LC().FLASHCARD}

                      <TooltipItem
                        key='2'
                        id='2'
                        content={this.state.tooltips[2].placement}
                        place_tip={this.state.tooltips[2].text_align}
                      />
                      <div className='float-right text-right'>
                        <img src={App_data.frontend_url + '/img/arrow_down_ico.png'} alt='' />
                      </div>
                    </div>
                    <div style={{ display: 'none' }} ref='flash_toggle_div'>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <ul className='comment_list_wrapper'>{this.state.flash_data}</ul>
                          </div>
                          <div className={this.state.flash_form}>
                            <form>
                              <textarea
                                id='flash_card'
                                name='flash_card'
                                rows='6'
                                className='form-control margin_bottom_10'
                                placeholder='Your flash card here'
                              />
                              <button
                                type='button'
                                className='btn btn-primary active pointer_class'
                                onClick={this._saveFlashCard.bind(this, this.state.currentReading)}
                              >
                                {language.LC().CREATE}
                              </button>
                              <p>
                                *
                                {
                                  language.LC()
                                    .FLASHCARDS_ONLY_SHOW_UP_TO_YOU_This_is_a_simple_way_to_take_notes_while_you_study
                                }
                              </p>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <ModalComponent
                  goPremium={this.goPremium.bind(this)}
                  toggleAlert={this.toggleAlert.bind(this)}
                  alert_status={this.state.alert_status}
                  MessageContent={this.state.MessageContent}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }
  resizeListener = () => {
    // write code here
    const windowwidth = window.innerWidth;
    const videoHeight = document.getElementById('video-height').offsetHeight;
    const listHeight = document.getElementById('video-tag-list');
    let importantHeight = `${videoHeight}px`;
    if (windowwidth > 992) {
      listHeight.setAttribute('style', `height: ${importantHeight} !important`);
    } else {
      listHeight.setAttribute('style', `height: auto !important`);
    }
  };
  async componentDidMount() {
    // set resize listener
    window.addEventListener('resize', this.resizeListener);
    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener('resize', this.resizeListener);
    };
  }

  render() {
    const windowwidth = window.innerWidth;
    const videoHeight = document.getElementById('video-height').offsetHeight;
    const listHeight = document.getElementById('video-tag-list');
    let importantHeight = `${videoHeight}px`;
    if (windowwidth > 992) {
      listHeight.setAttribute('style', `height: ${importantHeight} !important`);
    } else {
      listHeight.setAttribute('style', `height: auto !important`);
    }
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
          style={{ marginLeft: '4px' }}
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}
export default GMATvideodisplay;



// WEBPACK FOOTER //
// ./src/views/GMAT/VideoLessons/videodisplay.js